import { forwardRef, useImperativeHandle, useState } from "react";
import membersAPI from "../../../../services/members";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import MeaButton from "../../../../components/MeaButton";


const ChangeFatherModal = forwardRef((props, ref) => {

  const schoolId = props?.schoolId;
  const trainingId = props?.trainingId;
  const [student, setStudent] = useState();
  const [active, setActive] = useState(false);
  const [callbackFn, setCallbackFn] = useState(() => { });

  const [selectedMember, setSelectedMember] = useState(null);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const queryList = membersAPI.useGetList(schoolId, "", page, pageSize, {
    type: "parent",
    name: name,
    email: email,
    phone: phone,
  });

  useImperativeHandle(ref, () => ({
    show: (_student, _callback) => {
      setStudent(_student);
      setCallbackFn(() => _callback);
      setActive(true);
    },
  }));

  return (
    <Dialog header="Changer le père" visible={active}
      onHide={() => { setActive(false); setSelectedMember(null); setName(""); setEmail(""); setPhone(""); }}
      footer={
        <MeaButton
          label="Selectionner"
          icon="pi pi-check"
          onClick={() => {
            if (selectedMember) {
              callbackFn(selectedMember);
              setActive(false);
              setSelectedMember(null);
              setName("");
              setEmail("");
              setPhone("");
            }
          }}
          disabled={!selectedMember}
        />
      }>
      <p>
        Choisir un autre membre pour remplacer le père actuel.
      </p>
      <div className="flex flex-column gap-2 mb-3">
        <InputText
          placeholder="Filtrer par nom"
          onInput={(e) => setName(e.target.value)}
        />
        <InputText
          placeholder="Filtrer par e-mail"
          onInput={(e) => setEmail(e.target.value)}
        />
        <InputText
          placeholder="Filtrer par téléphone"
          onInput={(e) => setPhone(e.target.value)}
        />
      </div>
      <DataTable showGridlines value={queryList?.data?.data} selectionMode="single" selection={selectedMember}
        onSelectionChange={(e) => setSelectedMember(e.value)} dataKey="id"
        emptyMessage="Aucun membre trouvé!">
        <Column field="lastname" header="Nom" />
        <Column field="firstname" header="Prénom" />
        <Column field="email" header="E-mail" />
        <Column field="phone" header="Téléphone" />
      </DataTable>
    </Dialog>
  );

});

export default ChangeFatherModal;